import { createUrl, restGet, restPatch } from '~/src/dash/api/rest';

export async function getPublisherAPIToken(publisherID: string): Promise<string> {
  const reqUrl = createUrl('/publisher_api_token', publisherID);
  try {
    const response = await restGet<any>(reqUrl);
    return response?.parsedBody?.PublicAPIToken;
  } catch (err) {
    throw err;
  }
}

export async function updatePublisherAPIToken(
  publisherID: string,
  permissions: string,
): Promise<string> {
  const reqUrl = `${createUrl('/publisher_api_token', publisherID)}&permissions=${permissions}`;
  try {
    const response = await restPatch<any>(reqUrl, {});
    return response?.parsedBody?.PublicAPIToken;
  } catch (err) {
    throw err;
  }
}

export interface IThirdPartyAPIToken {
  Label: string;
  Token: string;
}

export async function getPublisherThirdPartyAPITokens(
  publisherID: string,
): Promise<[IThirdPartyAPIToken]> {
  const reqUrl = createUrl('/publisher_third_party_api_tokens', publisherID);
  try {
    const response = await restGet<any>(reqUrl);
    return response?.parsedBody || [];
  } catch (err) {
    throw err;
  }
}
